import { sortAppointmentsByTimeAsc } from '.';

export default function getFridayAppointmets(appointments) {
    const filterFridayAppointments = appointments.filter(
        item => new Date(item.data.date).getDay() === 5,
    );
    return sortAppointmentsByTimeAsc(filterFridayAppointments);
}
